/* Block - Image Grid.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */
import styles from "./block-image-grid.scss";

const imageGrids =  document.querySelectorAll('.block-image-grid');

imageGrids.forEach(imgGrid => {
    adjustPersonCards(imgGrid.id);
    window.innerWidth > 768 && adjustPersonTitles(imgGrid.id);
});

function adjustPersonTitles (id) {
    const groupPersonTitles = {};
    const positionToTop = {};
    const personTitles = document.querySelectorAll(`#${id} .rs-card__person-title`);

    // loop all person title to match height of titles on same row.
    personTitles.forEach(personTitle => {
        const rect = personTitle.getBoundingClientRect();
        const positionTop = rect.top + window.scrollY;
        if (!groupPersonTitles[positionTop]) {
            groupPersonTitles[positionTop] = [personTitle];
        } else {
            groupPersonTitles[positionTop].push(personTitle);
        }
        if (personTitle.offsetHeight > 26) {
            if (!positionToTop[positionTop]) {
                positionToTop[positionTop] = personTitle.offsetHeight;
            }
        }
    });

    // eslint-disable-next-line guard-for-in
    for (const key in positionToTop) {
        groupPersonTitles[key].forEach(personTitle => {
            personTitle.style.height = positionToTop[key] + 'px';
        });
    }
}

function adjustPersonCards (id) {
    const personCards = document.querySelectorAll(`#${id} .rs-card__caption`);

    personCards.forEach(card => {
        const readButton = document.createElement('button');
        readButton.innerHTML = '<span class="read-more">Read more</span><span class="read-less">Read less</span>';
        readButton.classList.add('read-btn');
        const lessText = document.createElement('p');
        lessText.classList.add('less-text');
        lessText.innerText = truncateString(card.children[0].innerText, 11);
        card.children[0].classList.add('more-text');
        card.appendChild(lessText);
        card.appendChild(readButton);
    });
    adjustReadButton();
}

function truncateString (str, num) {
    return str.split(' ').splice(0, num).join(' ');
}

function adjustReadButton () {
    const readBtns = document.querySelectorAll('.read-btn');

    readBtns.forEach(btn => {
        btn.addEventListener('click', function () {
            this.classList.toggle('active');
            this.parentElement.classList.toggle('open');
        });
    });
}
